// constants/pdfConfig.ts
export const PDF_SCALE = 1.5;
export const PDF_FONT_SIZE_OFFSET = 0.75;
export const Y_OFFSET_CORRECTION = -3; // ou -100 pour tester
export const Y_OFFSET_CORRECTION_PDF = -5;// Pour la génération du PDF



if (typeof PDF_SCALE !== 'number' || PDF_SCALE <= 0) {
  console.error('PDF_SCALE doit être un nombre positif');
}
if (typeof PDF_FONT_SIZE_OFFSET !== 'number' || PDF_FONT_SIZE_OFFSET <= 0) {
  console.error('PDF_FONT_SIZE_OFFSET doit être un nombre positif');
}

console.log("Y_OFFSET_CORRECTION utilisé :", Y_OFFSET_CORRECTION);

export {};